import { useMutation } from '@tanstack/react-query';

import { videoCallService, type MuteParticipantInput } from '../services';

interface MuteParticipantMutationInput extends MuteParticipantInput {
  sessionId: string;
}

/**
 * Mutation hook for POST /sessions/:id/call/mute. Practitioner +
 * admin only (enforced server-side). Result is propagated to all
 * clients via LiveKit's own event stream, so callers don't need to
 * revert UI state on error — LiveKit is the source of truth.
 */
export function useMuteParticipant() {
  return useMutation({
    mutationFn: ({ sessionId, ...input }: MuteParticipantMutationInput) =>
      videoCallService.muteParticipant(sessionId, input),
  });
}
